import React from 'react';
import { mapObject, constant } from 'underscore';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getToolbarHeaderStyles } from '../../styles';

const Header = ({
  classes, glyph, text, responsiveSize, svgicon,
}) => (
  <div className={classes.container}>
    {
    glyph
    ? <Glyphicon
        className={responsiveSize !== 'l' ? classes.regularButtonIcon : classes.compactButtonIcon}
        title={responsiveSize !== 'l' ? undefined : text}
        glyph={glyph}
    />
    : null
    }
    {svgicon && <div className={classNames(classes.svgicon, 'global-menu-toolbar-svg-icon')}>{svgicon}</div>}
    {responsiveSize !== 'l' && (
      <div className={classNames(classes.text, 'global-menu-toolbar-header-text')}>
        {text}
      </div>
    )}
  </div>
);

Header.defaultProps = {
  text: '',
  glyph: '',
  svgicon: undefined,
};

Header.propTypes = {
  classes: PropTypes.shape(mapObject(
    getToolbarHeaderStyles(),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  text: PropTypes.string,
  glyph: PropTypes.string,
  responsiveSize: PropTypes.string.isRequired,
  svgicon: PropTypes.node,
};

export const StyledHeader = withDefaultStyles(Header, getToolbarHeaderStyles);
